/* eslint-disable jsx-a11y/label-has-for */

// dependancies
import React from 'react'
import PropTypes from 'prop-types'

import styled from 'styled-components'

const CheckboxLabelStyled = styled.label`
  font-size: 1.4rem !important;

  * {
    font-size: inherit;
  }

  a {
    font-size: 1.4rem !important;
  }
`

const CheckboxLabel = (props) => {
  const { htmlFor, children, text } = props
  return (
    <CheckboxLabelStyled htmlFor={htmlFor}>
      {children ? children : text}
    </CheckboxLabelStyled>
  )
}

// props validation
CheckboxLabel.propTypes = {
  htmlFor: PropTypes.string.isRequired,
  text: PropTypes.array,
  children: PropTypes.node,
}

export default CheckboxLabel
